import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ApprovalAwards from "./index";
import { MODULE_APPROVAL_AWARDS } from "variables/modules";

const approvalAwardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Approval Awards",
        basePath: "approval-awards",
        mainComponent: <ApprovalAwards />,
        layout: "/console",	   
        subTitle:"Approval Awards",
        level:5,
        moduleId: MODULE_APPROVAL_AWARDS,
    })
]

export default approvalAwardRoutes;